import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./PublicCompliance.css";

export default function LeoPage() {
    const navigate = useNavigate();

    useEffect(() => {
        document.title = "DYC Compliance — LEO";
        return () => { document.title = "DYC Terminal"; };
    }, []);

    return (
        <div className="pc-page pc-page--error">
            <div className="pc-error-box">
                Full chain of custody report coming soon.
                <div style={{ marginTop: 16 }}>
                    <button className="pc-card-actions__btn" onClick={() => navigate(-1)}>
                        Go Back
                    </button>
                </div>
            </div>
        </div>
    );
}
